<div class="page-shell">
  <div class="page">
    <div class="hero">
      <div class="hero-text">
        <span class="eyebrow">Account activation</span>
        @if (loading) {
        <h2>Verifying your email</h2>
        <p>We are confirming your link and preparing your account.</p>
        }
        @if (!loading && (state === 'verified' || state === 'already_verified')) {
        <h2>Email confirmed</h2>
        <p>Your email has been verified. Set your password to continue with activation.</p>
        }
        @if (!loading && state === 'expired') {
        <h2>Verification link expired</h2>
        <p>This email link has expired. Request a fresh verification email to continue.</p>
        }
        @if (!loading && state === 'resent') {
        <h2>Verification email resent</h2>
        <p>Check your inbox for the new verification link.</p>
        }
        @if (!loading && state !== 'verified' && state !== 'already_verified' && state !== 'identity_pending' && state !== 'expired' && state !== 'resent') {
        <h2>Verification unavailable</h2>
        <p>{{ error || 'We could not confirm this verification link.' }}</p>
        }
      </div>
      <div class="hero-panel">
        <div class="step-pill">
          @if (loading) { Verifying }
          @if (!loading && (state === 'verified' || state === 'already_verified')) { Confirmed }
          @if (!loading && state === 'expired') { Expired }
          @if (!loading && state === 'resent') { Resent }
          @if (!loading && state !== 'verified' && state !== 'already_verified' && state !== 'expired' && state !== 'resent') { Stopped }
        </div>
        <div class="hero-title">Activation</div>
        <div class="hero-subtitle">Email is the proof for this step.</div>
      </div>
    </div>

    <section class="card">
      @if (loading) {
      <p>Preparing your account...</p>
      }

      @if (!loading && (state === 'verified' || state === 'already_verified')) {
      <div class="layout">
        <div class="header">
          <h3>Create your password</h3>
          <p class="intro">Your email is already verified. Set your password here to continue activation.</p>
        </div>

        <form [formGroup]="activationForm" class="form" (ngSubmit)="submitActivation()">
          <mat-form-field class="field input">
            <mat-label>Verified Email</mat-label>
            <input matInput formControlName="email" readonly>
          </mat-form-field>

          <mat-form-field class="field input">
            <mat-label>Password</mat-label>
            <input
              matInput
              [type]="passwordVisible ? 'text' : 'password'"
              formControlName="password"
              autocomplete="new-password"
              [readonly]="activationInFlight"
            >
            <button
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="passwordVisible ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="passwordVisible"
              (click)="togglePasswordVisibility('password')"
            >
              <mat-icon>{{ passwordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (fieldError('password')) {
            <mat-error>{{ fieldError('password') }}</mat-error>
            }
          </mat-form-field>

          <div class="password-rules">
            @for (rule of passwordRules(); track rule.label) {
            <div class="password-rule" [class.met]="rule.met">
              <span class="rule-indicator">{{ rule.met ? 'OK' : '...' }}</span>
              <span>{{ rule.label }}</span>
            </div>
            }
          </div>

          <mat-form-field class="field input">
            <mat-label>Confirm Password</mat-label>
            <input
              matInput
              [type]="confirmPasswordVisible ? 'text' : 'password'"
              formControlName="confirmPassword"
              autocomplete="new-password"
              [readonly]="activationInFlight"
            >
            <button
              mat-icon-button
              matSuffix
              type="button"
              [attr.aria-label]="confirmPasswordVisible ? 'Hide confirm password' : 'Show confirm password'"
              [attr.aria-pressed]="confirmPasswordVisible"
              (click)="togglePasswordVisibility('confirmPassword')"
            >
              <mat-icon>{{ confirmPasswordVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (fieldError('confirmPassword')) {
            <mat-error>{{ fieldError('confirmPassword') }}</mat-error>
            }
          </mat-form-field>

          <div class="form-actions">
            <button
              mat-raised-button
              color="primary"
              class="primary-action"
              type="submit"
              [disabled]="activationInFlight || activationForm.invalid"
            >
              {{ activationPreparing ? 'Preparing account...' : activationInFlight ? 'Activating...' : 'Activate account' }}
            </button>
          </div>
        </form>
      </div>
      }

      @if (!loading && state === 'expired') {
      <h3>Request a new link</h3>
      <p>{{ error }}</p>
      <div class="actions">
        <button class="primary-link" type="button" (click)="resendVerification()" [disabled]="resendInFlight">
          {{ resendInFlight ? 'Sending...' : 'Resend verification email' }}
        </button>
      </div>
      }

      @if (!loading && state === 'resent') {
      <h3>Check your inbox</h3>
      <p>A fresh verification email is on the way.</p>
      }

      @if (!loading && state !== 'verified' && state !== 'already_verified' && state !== 'expired' && state !== 'resent') {
      <h3>Unable to continue</h3>
      <p>{{ error }}</p>
      }
    </section>
  </div>
</div>
